import { render } from "./HelloWorld.vue?vue&type=template&id=12d17458"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=12d17458&lang=css"

import exportComponent from "C:\\Users\\weil\\Desktop\\bimbot\\repo\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__